<template>
  <SlideOut
    class="dashboard-slide-out"
    :show="show"
    :completeDisabled="disabled"
    @cancel="$emit('cancel')"
    @complete="$emit('complete')"
  >
    <template v-slot:header>
      <span>{{ label }}</span>
      <slot name="headerContent"></slot>
    </template>
    <template v-slot:content>
      <slot name="slideOutContent"></slot>
    </template>
    <template v-slot:complete>
      Apply
    </template>
  </SlideOut>
</template>
<script>
import { SlideOut } from '@mikmak/components';

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
  components: {
    SlideOut,
  },
};
</script>
<style>
.dashboard-slide-out .actions .main-button-wrapper {
  width: 100%;
}

.dashboard-slide-out p.content {
  margin-bottom: 75px;
}
</style>
